export default ({ app }) => {
  app.router.afterEach((to, from) => {
    setTimeout(() => {
      if (from?.name !== null && app.$gtag) {
        app.$gtag('event', 'page_view')
      }
    }, 250)
  })
}
